import { CONST } from "../../CONST";
import { GridFillScene } from "../../scenes/GridFillScene";

interface CountdownConfig{
    scene: GridFillScene,
    position: {x: number, y: number},
    duration: number,
    onComplete: ()=>void,//Function,
}

const CONFIG = {
    width: 250,
    height: 15,
    depth: 40,

    startTween: {
        from: {y: -100},
        ease: "Quad.easeOut",//"Back.easeOut",
        duration: 500,
    },

    endTween: {
        to: {y: -100},
        ease: "Quad.easeIn", //"Back.easeIn",
        duration: 500,
        delay: 500,
    }
}

export class Countdown extends Phaser.GameObjects.Container{
    public config: CountdownConfig;

    private currentDuration: number;
    private isCountingDown: boolean;
    private timer !: Phaser.Time.TimerEvent;

    private countdownImage !: Phaser.GameObjects.Image; 
    private maskShape !: Phaser.GameObjects.Graphics;
    private countdownStartX = 0;
    private countdownMoveX = 0;

   constructor(config: CountdownConfig){
       super(config.scene, config.position.x, CONFIG.startTween.from.y);
        this.config = config;

        this.currentDuration = config.duration;
        this.isCountingDown = false;

        this.setScale(0.9);
        this.createChildren();
        this.setLoadingBarPercentage(1);
        this.setScrollFactor(0);

        config.scene.add.existing(this);

        this.config.scene.tweens.add({
            targets: this,
            y: config.position.y,
            ease:  CONFIG.startTween.ease,
            duration: CONFIG.startTween.duration
        });
    }

    public startCountdown(){
        this.timer = this.config.scene.time.addEvent({
            delay: this.config.duration,
            callback: this.config.onComplete,
        });

        this.isCountingDown = true;
        return this;
    }

    public stopCountdown(){
        this.timer.paused = true;

        this.config.scene.tweens.add({
            targets: this,
            y: CONFIG.endTween.to.y,
            ease:  CONFIG.endTween.ease,
            duration: CONFIG.endTween.duration,
            delay: CONFIG.endTween.delay,
        });
    }

    public getRemainingTimeShare(){
        return (1-this.timer.getProgress());
    }

    public getElapsedTime(){
        return this.timer.getProgress() * this.currentDuration;
    }

    public getTotalTime(){
        return this.currentDuration;
    }

    destroy(){
        this.timer.remove(false);
        this.maskShape.destroy();
        super.destroy();
    }

    private createChildren(){
        let c1 = this.config.scene.add.image(0, 0, CONST.GRID_FILL.COUNTDOWN_1); //bg
        let c3 = this.config.scene.add.image(1, 2, CONST.GRID_FILL.COUNTDOWN_3); //white bg


        this.countdownImage = this.config.scene.add.image(this.x+1, this.y+2, CONST.GRID_FILL.COUNTDOWN_2).setScrollFactor(0).setScale(this.scaleX, this.scaleY);
    

        this.maskShape = this.config.scene.add.graphics().fillStyle(0xffffff, 0).beginPath().fillRect(this.countdownImage.getTopLeft().x, 0, this.countdownImage.displayWidth, 500).setDepth(CONFIG.depth+1);
        this.countdownStartX = this.maskShape.x;
        this.countdownMoveX = this.countdownImage.displayWidth;

          var mask = this.maskShape.createGeometryMask();
          this.countdownImage.setMask(mask);
        
        this.add([c1, c3]);
    }

    private setLoadingBarPercentage(percentage: number){
         this.maskShape.x = this.countdownStartX - (1-percentage) * this.countdownMoveX;
    }

    public onUpdate(){
        if (!this.isCountingDown){
            return;
        }

        this.setLoadingBarPercentage(this.getRemainingTimeShare());
        this.updateCountdownDisplay();
    }

    private updateCountdownDisplay(){
       if (!this.countdownImage) return;
       this.countdownImage.setPosition(this.x+1, this.y+2).setDepth(this.depth + 1);
    }
}